
import { MainLayout } from '@/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EngineChart } from '@/features/data-analytics/components/EngineChart';
import { AlertPanel } from '@/features/alert-system/components/AlertPanel';
import { useEngineStore } from '@/features/engine-monitoring/stores/engine';
import { useAlertStore } from '@/features/alert-system/stores/alert';
import { Ship, Activity, AlertTriangle, TrendingUp } from 'lucide-react';

const Index = () => {
  const { engines, criticalEngines } = useEngineStore();
  const { unacknowledgedCount, criticalCount } = useAlertStore();

  const stats = [
    {
      title: '总发动机数',
      value: engines.length,
      icon: Activity,
      color: 'text-blue-600',
    },
    {
      title: '运行状态异常',
      value: criticalEngines.length,
      icon: AlertTriangle,
      color: 'text-red-600',
    },
    {
      title: '未处理告警',
      value: unacknowledgedCount,
      icon: AlertTriangle,
      color: 'text-yellow-600',
    },
    {
      title: '紧急告警',
      value: criticalCount,
      icon: TrendingUp,
      color: 'text-red-600',
    },
  ];

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">系统总览</h1>
            <p className="text-muted-foreground">船舶数字孪生监控系统</p>
          </div>
          <Ship className="h-8 w-8 text-blue-600" />
        </div>

        {/* 统计卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <Card key={stat.title}>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
                <stat.icon className={`h-4 w-4 ${stat.color}`} />
              </CardHeader>
              <CardContent>
                <div className={`text-2xl font-bold ${stat.color}`}>
                  {stat.value}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* 主要内容区域 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <EngineChart />
          <div>
            <AlertPanel />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Index;
